<template>
  <v-dialog :value="true" fullscreen persistent scrollable>
    <v-card>
      <v-card-title class="text-h3 primary--text justify-center"
        >AVISO DE PRIVACIDAD</v-card-title
      >
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap class="black--text text-h5">
            <v-flex xs12>
              En cumplimiento con la Ley Federal de Protección de Datos
              Personales en Posesión de los Particulares vigente, en lo sucesivo
              denominada como “La Ley”, Servacare S.A de C.V., sus subsidiarias
              y filiales, en lo sucesivo “Servacare”, con domicilio para oír y
              recibir notificaciones el ubicado en Calzada de Tlalpan 4867 bis,
              Colonia La Joya, Delegación Tlalpan, Código Postal 14000, Ciudad
              de México, que es la sociedad mercantil responsable del uso y
              protección de sus datos personales, le informa lo siguiente:
            </v-flex>
            <v-flex xs12>
              Los datos personales que en este acto se recaban de Usted, los
              utilizaremos para las siguientes finalidades, que son necesarias
              para brindarle de entre nuestros servicios y/o productos, los que
              son de su interés:
            </v-flex>
            <v-flex xs12>
              <ul>
                <li>
                  Dar seguimiento a las solicitudes de informes y dudas en
                  relación con los servicios y/o productos de Servacare.
                </li>
                <li>
                  Contratar y dar seguimiento a la contratación de estudios
                  médicos, promociones, paquetes y demás servicios y/o productos
                  ofrecidos por Servacare a través de su portal de internet para
                  realizar el trámite de facturación electrónica.
                </li>
                <li>
                  Canalizarlo al área correspondiente a fin de atender su
                  solicitud con relación a dichos servicios y/o productos
                </li>
                <li>
                  Sus datos personales podrán ser utilizados para ponerse en
                  contacto con usted y dar seguimiento a las cuestiones
                  anteriores.
                </li>
                <li>
                  El contacto que Servacare realice podrá ser a través de su
                  página de internet, correo electrónico, teléfono, WhatsApp,
                  mensajes de texto, mensajes instantáneos, redes sociales y en
                  general, cualquier medio electrónico.
                </li>
                <li>
                  Para desarrollar las actividades intrínsecas a su giro
                  comercial, fines administrativos y para cumplir con cualquier
                  obligación legal, así como para defender o entablar una
                  demanda, reclamación, queja o trámite ante alguna autoridad.
                </li>
                <li>
                  Para el intercambio de información científica y educativa con
                  médicos y/o pacientes, para la creación de directorios para
                  entrega de productos y comunicaciones y encuestas de servicio,
                  así como para la creación de redes de médicos para el
                  desarrollo, promoción y seguimiento de Servicios y/o productos
                  de Servacare
                </li>
                <li>
                  El tipo de datos personales que se pueden tratar en este
                  servicio son: Generales de Identificación, Generales Laborales
                  y Generales Académicos.
                </li>
                <li>
                  El tipo de datos personales que se pueden tratar en este
                  servicio son: Generales de Identificación, Generales Laborales
                  y Generales Académicos.
                </li>
                <li>
                  En el caso de servicios que requieran de tomarle muestras
                  biológicas, una vez entregado el resultado de los análisis
                  practicados a las mismas, cualquier remanente podrá ser
                  resguardado para uso futuro en proyectos de investigación, con
                  la condición de anonimizarlas para que ya no sean rastreables
                  a su persona y con ello se proteja su privacidad y la de los
                  suyos en todo momento.
                </li>
              </ul>
            </v-flex>
            <v-flex
              xs12
              class="text-h3 primary--text justify-center text-center"
            >
              Firma de Conformidad:
            </v-flex>
            <v-flex xs12>
              <canvas id="firma" height="500"></canvas>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn class="mr-5" text @click.prevent="cerrar"> Cancelar</v-btn>
        <v-spacer> </v-spacer>

        <v-btn class="mr-5" text @click.prevent="limpiar"> Limpiar</v-btn>
        <v-btn color="primary" @click.prevent="guardar"
          ><v-icon>check</v-icon> Aceptar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SignaturePad from 'signature_pad';
export default {
  name: 'avisoPrivacidad',
  data() {
    return {
      signaturePad: null,
    };
  },
  mounted() {
    var canvas = document.getElementById('firma');
    canvas.width = window.innerWidth;
    this.signaturePad = new SignaturePad(canvas, {
      backgroundColor: 'rgb(255, 255, 255)', // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
    });
  },
  methods: {
    limpiar() {
      this.signaturePad.clear();
    },
    cerrar() {
      this.$emit('cerrar');
    },
    guardar() {
      /*
      if (this.signaturePad.isEmpty()) {
        this.$root.mensajeError = 'Por favor ingrese su firma para continuar';
        return;
      }*/
      this.$emit('cerrar', this.signaturePad.toDataURL('image/jpeg'));
    },
  },
};
</script>
